if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.classList.contains("cart__summary")) {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
        if (item.target.classList.contains("js-search-results")) {
          handleCartDrawerFooterMutation();
        }
        if (item.target.id === "cart-icon-bubble") {
          handleTEBox();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    if(window.location.pathname.includes('/products/')){
      let interval = setInterval(() => {
        if(BSS_B2B?.observer?.productSubject){
          clearInterval(interval)
          BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate')
        }
      }, 200)
      setTimeout(() => clearInterval(interval), 5000);
    }
  }, 300);
  async function handleCartDrawerFooterMutation() {
    if (BSS_B2B) {
      const res = await BSS_B2B.storage.productStorage.load();
      if (res) {
        if (
          res.notExistProductIds?.length ||
          res.productIds?.length ||
          res.variantIds?.size
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "LazyProduct",
            "LoadedLazyProduct",
            {
              ...res,
            }
          );
        }
      }
    }
  }
  const pageType =
    window.ShopifyAnalytics &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.page &&
    window.ShopifyAnalytics.meta.page.pageType;

  if (pageType !== "cart") {
    let counter = 0;
    const interval = setInterval(() => {
      const footerPrice = document.querySelector(
        ".cart-drawer__checkout-buttons"
      );

      if (footerPrice) {
        handleTEBox();
        clearInterval(interval);
      } else {
        counter += 100;
        if (counter >= 10000) {
          clearInterval(interval);
        }
      }
    }, 100);
  } else {
    let counter = 0;
    const interval = setInterval(() => {
      const vatInputWrapper = document.querySelector(
        ".bss-b2b-vat-input-wrapper"
      );

      if (vatInputWrapper) {
        handleTEBox();
        clearInterval(interval);
      } else {
        counter += 100;
        if (counter >= 10000) {
          clearInterval(interval);
        }
      }
    }, 100);
  }

  function handleTEBox() {
    const translations = BSS_B2B.te.teTranslations;
    const headerText = document.querySelector(
      ".bss-b2b-translation-vat-form_header_text"
    );
    if (headerText) {
      headerText.innerText = translations.form_header_text;
    }

    const subtitleText = document.querySelector(
      ".bss-b2b-translation-vat-form_subtitle_text"
    );
    if (subtitleText) {
      subtitleText.innerText = translations.form_subtitle_text;
    }

    const successMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_success_message"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_uk"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_abn"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_gst"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_us_ein"
      ),
    ];

    successMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_success_message || "";
            break;
          case 1:
            msg.innerText = translations.form_success_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_success_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_success_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_success_message_us_ein || "";
            break;
        }
      }
    });

    const errorMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_error_message"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_error_message_us_ein"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_validate_country_code_message"
      ),
    ];

    errorMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_error_message || "";
            break;
          case 1:
            msg.innerText = translations.form_error_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_error_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_error_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_error_message_us_ein || "";
            break;
          case 5:
            msg.innerText =
              translations.form_validate_country_code_message || "";
            break;
        }
      }
    });
  }
}

setTimeout(() => {
    const btn = document.querySelector(`button[name="checkout"]`);
    if(btn){
      btn.addEventListener('click', (e) => {
        console.log(123);
        const cartTermsCheckbox = document.querySelector('input#cart-terms');
         if (!cartTermsCheckbox.checked) {
               e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
              alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
            }
      })
    }
}, 300)
